import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import Draggable from "react-draggable";
import ModalDialog from "react-bootstrap/ModalDialog";
import {
  ADDED_FIELDS_WARNING,
  REMOVE_REGISTERED_FIELD_NOTE,
} from "../../configurations/MessageConstants";
import { EMPTY } from "../../configurations/Constants";

function DraggableModalDialog(props) {
  return (
    <Draggable handle=".modal-header">
      <ModalDialog {...props} />
    </Draggable>
  );
}

function ConfirmPopUp(props) {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [deleteFieldNote, setDeleteFieldNote] = useState(
    REMOVE_REGISTERED_FIELD_NOTE
  );

  const resetState = () => {
    setButtonClicked(false);
    setDeleteFieldNote(REMOVE_REGISTERED_FIELD_NOTE);
  };

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      setButtonClicked(false);
      mounted.current = false;
    } else {
      resetState();
    }
  });

  const handleAddRequest = async (event) => {
    setButtonClicked(true);
    props.performWarningAction(event);
  };

  let closeModal = () => {};

  return (
    <Modal
      dialogAs={DraggableModalDialog}
      show={props.showConfirmPopup}
      onHide={closeModal}
      className="confirm-modal confirm-box"
    >
      <Modal.Header>
        <h3>
          {props.addedFieldStatus > 0 && props.irrig_unit_Id === EMPTY
            ? "Warning"
            : props.header}
        </h3>
        <CloseButton
          className="close field-close"
          variant="white"
          onClick={(event) => props.closeWarningPopup(event)}
        />
      </Modal.Header>
      <Modal.Body>
        {props.addedFieldStatus > 0 && props.irrig_unit_Id === EMPTY ? (
          <div>
            <p color="muted">
              <span>{ADDED_FIELDS_WARNING}</span>
            </p>

            <Button type="button" onClick={(e) => props.closeWarningPopup(e)}>
              OK
            </Button>
          </div>
        ) : (
          <div>
            <p color="muted">
              {props.message}
              <br />
            </p>
            {props.message.includes("remove registered field") ? (
              <span color="muted">{deleteFieldNote}</span>
            ) : (
              EMPTY
            )}
            {props.noActionRequired === true ? (
              <div>
                <br />
                <Button
                  type="button"
                  onClick={(e) => handleAddRequest(e)}
                  disabled={buttonClicked ? true : false}
                >
                  {props.confirmButton ? props.confirmButton : "Yes"}
                </Button>{" "}
                {EMPTY}
                <Button
                  type="button"
                  onClick={(e) => props.closeWarningPopup(e)}
                >
                  {props.cancelButton ? props.cancelButton : "No"}
                </Button>
              </div>
            ) : (
              <Button type="button" onClick={(e) => props.closeWarningPopup(e)}>
                OK
              </Button>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmPopUp;
